import React, { useState } from "react";
import Layout from "./components/layout";
import Navbar from "./components/navbar";

export const TabKey = {
  Home: "Home",
  Work: "Work",
  Blog: "Blog",
  Contact: "Contact",
};

function App() {
  const [tab, setTab] = useState(TabKey.Home);
  const [x, setX] = useState(0);
  const [w, setW] = useState(0);

  return (
    <main className="bg-[#00000000] ">
      <Navbar
        tab={tab}
        setTab={setTab}
        left={x}
        sliderWidth={w}
        setX={setX}
        setW={setW}
      />
      <Layout tab={tab} setTab={setTab} left={x} sliderWidth={w} />
    </main>
  );
}

export default App; 